module.exports = __WEBPACK_EXTERNAL_MODULE_66__;


//////////////////
// WEBPACK FOOTER
// external {"root":"Vue","commonjs":"vue","commonjs2":"vue","amd":"vue"}
// module id = 66
// module chunks = 0